export default class BlockCtaList {

    constructor(container, options) {
        const defaultOptions = {
            plyr: '.video-plyr',
            moduleContainer: '.cta-list-modal',
            loaderEnabled: false
        };
		
        this.options = Object.assign({}, defaultOptions, options);
        this.container = document.querySelector(container);

        if (this.container) {
            this.plyr = this.container.querySelector(this.options.plyr);
            this.moduleContainer = this.container.querySelector(this.options.moduleContainer);
            this.init();         
            this.setModal();
        }
    }

    setModal() {
        var whitebG = this.container.querySelector(".white-bg")
        var modal = this.container.querySelector(".cta-list-modal");
        var modalOpenButton = this.container.querySelector("a.cta-modal-trigger");
        var modalCloseButton = this.container.querySelector("svg.cta-list-icon-modal-close");

		var $this = this;
		
        if (modalOpenButton) {
            modalOpenButton.addEventListener("click", function(e){

				$this.videoPlayer.play();				
				whitebG.style.display = "block";
                modal.style.display = "block";
                modalCloseButton.style.display = "block";
				
            });
        }

        if (modalCloseButton) {
            modalCloseButton.addEventListener("click", function(e){           
				$this.videoPlayer.stop();
				whitebG.style.display = "none";
                modalCloseButton.style.display = "none";				
                modal.style.display = "none";			
            });
        }

    }

    init() {

        this.videoPlayer = new Plyr(this.plyr, {
            controls: [
                'play-large',
                'play',
                'progress',
                'mute',
                'fullscreen',
                'volume'
            ],
            debug: false,
            volume: 1,
            autoplay: false
        });

        // Set the poster after initialization
        this.videoPlayer.poster = this.plyr.dataset.poster;

        this.videoPlayer.on('ready', () => {
            this.moduleContainer.classList.add('active');
            this.videoPlayer.volume = 1
        });

    }
}

